import React, { useContext, useEffect, useState } from "react";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import AuthContext from "../../Context/autenticacion/authContext";
import {
  Grid,
  Typography,
  Container,
  Box,
  Card,
  CardActionArea,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import CategoryIcon from "@material-ui/icons/Category";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import PeopleIcon from "@material-ui/icons/People";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "calc(100vh - 64px)",
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 24,
    background: "linear-gradient(50deg, #ce93d8 33%, #e1bee7 100%)",
    padding: theme.spacing(6, 4),
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(8, 6),
    },
  },
  heroPattern: {
    position: "absolute",
    inset: 0,
    backgroundImage: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSIyIi8+PC9nPjwvZz48L3N2Zz4=")`,
    opacity: 0.5,
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
  },
  greetingText: {
    fontSize: "1.125rem",
    fontWeight: 500,
    color: "rgba(255, 255, 255, 0.9)",
    marginBottom: theme.spacing(1),
    opacity: 0,
    animation: "$fadeIn 0.5s ease forwards",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.25rem",
    },
  },
  userName: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: theme.spacing(2),
    opacity: 0,
    transform: "translateY(16px)",
    animation: "$slideUp 0.7s ease forwards 0.2s",
    [theme.breakpoints.up("md")]: {
      fontSize: "3.75rem",
    },
  },
  welcomeSubtitle: {
    color: "rgba(255, 255, 255, 0.8)",
    fontSize: "0.875rem",
    maxWidth: 400,
    margin: "0 auto",
    [theme.breakpoints.up("md")]: {
      fontSize: "1rem",
    },
  },
  cardsContainer: {
    marginTop: theme.spacing(4),
  },
  navigationCard: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 16,
    aspectRatio: "4/3",
    boxShadow: "0 10px 40px -10px rgba(0, 0, 0, 0.3)",
    transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
    opacity: 0,
    transform: "translateY(32px)",
    animation: "$slideUp 0.5s ease forwards",
    "&:hover": {
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.4)",
      transform: "scale(1.02)",
      "& $cardImage": {
        transform: "scale(1.1)",
      },
      "& $cardOverlay": {
        background: "linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)",
      },
      "& $cardDescription": {
        opacity: 1,
      },
      "& $cardUnderline": {
        width: 48,
      },
      "& $iconWrapper": {
        transform: "scale(1.1)",
        background: "rgba(255, 255, 255, 0.3)",
      },
    },
  },
  cardActionArea: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  cardImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "transform 0.7s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  cardOverlay: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 40%, transparent 100%)",
    transition: "background 0.3s ease",
  },
  cardContent: {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
    color: "#ffffff",
    height: "100%",
    justifyContent: "flex-end",
  },
  iconWrapper: {
    marginBottom: theme.spacing(1.5),
    borderRadius: "50%",
    backdropFilter: "blur(4px)",
    transition: "all 0.3s ease",
  },
  cardIcon: {
    width: 24,
    height: 24,
    color: "#ffffff",
  },
  cardTitle: {
    fontSize: "1.125rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textAlign: "center",
  },
  cardDescription: {
    fontSize: "0.875rem",
    color: "rgba(255, 255, 255, 0.7)",
    marginTop: theme.spacing(0.5),
    opacity: 0,
    transition: "opacity 0.3s ease",
    textAlign: "center",
  },
  cardUnderline: {
    marginTop: theme.spacing(1),
    height: 2,
    width: 0,
    background: "#ffffff",
    transition: "width 0.3s ease",
  },
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  "@keyframes slideUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(32px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
}));

const navigationItems = [
  {
    url: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=800&auto=format&fit=crop&q=80",
    title: "VENTAS",
    href: "/Ventas",
    Icon: ShoppingCartIcon,
    description: "Gestiona tus ventas",
  },
  {
    url: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=800&auto=format&fit=crop&q=80",
    title: "PRODUCTOS",
    href: "/Productos",
    Icon: CategoryIcon,
    description: "Administra productos",
  },
  {
    url: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800&auto=format&fit=crop&q=80",
    title: "INSCRIPCIONES",
    href: "/Inscripciones",
    Icon: PersonAddIcon,
    description: "Nuevas inscripciones",
  },
  {
    url: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&auto=format&fit=crop&q=80",
    title: "CLIENTES",
    href: "/Clientes",
    Icon: PeopleIcon,
    description: "Base de clientes",
  },
];

function getGreeting() {
  const hour = new Date().getHours();
  if (hour >= 6 && hour < 12) return "Buenos Días";
  if (hour >= 12 && hour < 18) return "Buenas Tardes";
  return "Buenas Noches";
}

const Home = () => {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const { usuarioAutenticado, usuario } = authContext;

  const [saludo, setSaludo] = useState("");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    usuarioAutenticado();
    setSaludo(getGreeting());
    setMounted(true);
  }, []);

  return (
    <LayoutDashboard>
      <Box className={classes.root}>
        <Container maxWidth="lg">
          {/* Hero Section */}
          <Box className={classes.heroSection}>
            <Box className={classes.heroPattern} />
            <Box className={classes.heroContent}>
              <Typography
                className={classes.greetingText}
                style={{ opacity: mounted ? 1 : 0 }}
              >
                {saludo}
              </Typography>
              <Typography
                variant="h1"
                className={classes.userName}
                style={{
                  opacity: mounted ? 1 : 0,
                  transform: mounted ? "translateY(0)" : "translateY(16px)",
                }}
              >
                {usuario?.name}
              </Typography>
              <Typography className={classes.welcomeSubtitle}>
                Bienvenido a tu panel de control.
                <br />
                Selecciona una opción para comenzar.
              </Typography>
            </Box>
          </Box>

          {/* Navigation Cards */}
          <Grid container spacing={3} className={classes.cardsContainer}>
            {navigationItems.map((item, index) => (
              <Grid item xs={12} sm={6} lg={3} key={item.title}>
                <Card
                  className={classes.navigationCard}
                  style={{
                    animationDelay: `${index * 100}ms`,
                    opacity: mounted ? 1 : 0,
                  }}
                >
                  <CardActionArea
                    href={item.href}
                    className={classes.cardActionArea}
                  >
                    <Box
                      className={classes.cardImage}
                      style={{ backgroundImage: `url(${item.url})` }}
                    />
                    <Box className={classes.cardOverlay} />
                    <Box className={classes.cardContent}>
                      <Box className={classes.iconWrapper}>
                        <item.Icon className={classes.cardIcon} />
                      </Box>
                      <Typography className={classes.cardTitle}>
                        {item.title}
                      </Typography>
                      <Typography className={classes.cardDescription}>
                        {item.description}
                      </Typography>
                      <Box className={classes.cardUnderline} />
                    </Box>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </LayoutDashboard>
  );
};

export default Home;
